import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const getForms = (state: ApplicationState) => {
    return state.toolkit.components.form.forms;
};

export const getFormById = (state: ApplicationState, id: string) => {
    return getForms(state).find(x => x.id === id) || null;
};

export const getInputs = (state: ApplicationState, formId: string) => {
    return getFormById(state, formId)?.inputs || [];
};

export const getInputById = (state: ApplicationState, inputId: string | number, formId: string) => {
    return getInputs(state, formId).find(x => x.id === inputId) || null;
};

export const getFirstInputInError = (state: ApplicationState, formId: string) => {
    return getInputs(state, formId).find(x => x.error !== undefined && x.error !== "") || null;
};

export const hasErrorInForm = (state: ApplicationState, formId: string) => {
    return getInputs(state, formId).some(x => x.error);
};
